export type ApiKey = string;
export type Shop = string;

export const CHAT_EVENTS_ENDPOINT = '/c/v1/chat-events';
export interface WindowApi {
  a: ApiKey;
  b: Shop;
  q: unknown[];
}

export type PublicCallback = (...args: any[]) => void;

export interface KustomerErrorResponse extends Error {
  title?: string;
  status?: string;
  source?: any;
  url?: string;
  type?: string;
}

export interface PreviewAssistantOptions {
  draft?: boolean;
  emulation?: boolean;
}
